import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ParentDetails, ChildDetail } from '../../../../../model/km-jour.model';
import { ToolKmJourService } from '../../../../../services/tool-km-jour.service';
import { Subscription } from 'rxjs';
import { DataManagementService, Vehicule } from 'src/app/client-management/data-management';
import { RealtimeService } from 'src/app/client-management/realtime/services/realtime.service';
import { MapService } from 'src/app/utils/leaflet/service/map.service';
import { DateInterval } from 'src/app/shared/model';
import { RealtimeProcessingService } from 'src/app/client-management/realtime/services/real-time-processing.service';
import { ChartParametre } from 'src/app/client-management/realtime/model/chart-parameter.model';
import { ActivatedRoute, Router } from '@angular/router';



@Component({
  selector: 'km-jour-trajet-parent',
  templateUrl: './km-jour-trajet-parent.component.html',
  styleUrls: ['./km-jour-trajet-parent.component.css'],
})
export class KmJrTrajetParentComponent implements OnInit, OnDestroy {
  @Output('showingItems') showingItems =  new EventEmitter();
  @Input() useFms: boolean;
  @Input() parentDetails: ParentDetails;
  @Output('displayDash') displayDash = new EventEmitter<ChartParametre>();

  intervaleDate: DateInterval;  
  intervaleDateSubscription: Subscription;

  dates: Date[]= [];
  currentDate:number = 0;

  loadedSuscription: Subscription;
  isDataLoaded: boolean = false;

  selectedVehicule: Vehicule;
  selectedVehiculeSubs: Subscription;

  isMultiSelectTrajet = false;
  isMultiSelectTrajet$ : Subscription;
  selectedTrajets: ChildDetail[] = [];
  selectedTrajets$: Subscription;
  fullTrajets: ChildDetail[] = [];
  fullTrajets$: Subscription;



  constructor(private toolKmJourService: ToolKmJourService,
    private realTimeService: RealtimeService,
    private mapService: MapService,
    public dataManagementService: DataManagementService,
    private realTimeProcessing: RealtimeProcessingService,
    private route: ActivatedRoute,
    private router: Router
    ) {}

  ngOnInit() {
    this.loadVehicule();
    this.loadedSuscription= this.toolKmJourService.isLoaded().subscribe(isLoaded => {
      this.isDataLoaded = isLoaded;
    });
    this.isMultiSelectTrajet$ = this.toolKmJourService.getIsMultiSelectTrajet().subscribe((isMultiSelect) => {
      this.isMultiSelectTrajet = isMultiSelect;
    });
    this.selectedTrajets$ = this.toolKmJourService.getMultiSelectTrajet().subscribe((trajets) => {
      this.selectedTrajets = trajets;
    });
    this.fullTrajets$ = this.toolKmJourService.getKmJourPath().subscribe((trajets) => {
      this.fullTrajets = trajets?.childDetails || [];
    });
    this.intervaleDateSubscription= this.realTimeProcessing.getIntervalDate().subscribe((interval) => {
      this.intervaleDate = interval;
      this.toolKmJourService.setKmJourPath(null);
      this.mapService.clearPolylines();
      this.mapService.removeMarkersAndClearArrays();
      this.toolKmJourService.loadKmJourPath(this.selectedVehicule.idDevice,this.intervaleDate);
      this.currentDate= -1;
    })
  }
  calculeConsumation(consumtion: any){
    if(!consumtion || consumtion > 100){return 0}
    else{
      return consumtion;
    }
  }

   toggleMultiSelect(event: any) {
    event.stopPropagation();
    this.toolKmJourService.setIsMultiSelectTrajet(!this.isMultiSelectTrajet);
    if (!this.isMultiSelectTrajet) {
      this.toolKmJourService.clearMultiSelectTrajet();
    }
  }

  playSelected(event: any) {
    event.stopPropagation();
    const childDetail = (this.selectedTrajets.length === 0) ? this.toolKmJourService.mapListOfChildDetailsToSingleChildDetail(this.fullTrajets) : this.toolKmJourService.groupChildDetails();
    if(childDetail){
      this.toolKmJourService.setChildPath(childDetail);
      this.toolKmJourService.setDestination('../');
      this.realTimeService.setBarToolStatus(false);
      this.router.navigate(['trajet'], {relativeTo: this.route});
      this.displayDash.emit({
        intervald: {startDate: childDetail.beginPathTime, 
          endDate: childDetail.endPathTime}, 
          time: 5,
          height: 150, 
          fontSize: "10px"
      })
    }
  }


  loadVehicule(){
    this.selectedVehiculeSubs = this.realTimeService
    .getVehicule()
    .subscribe((v) => {
      this.selectedVehicule = v; 
    });
  }

  showItem(){
    this.showingItems.emit();
  }

  ngOnDestroy(){
    this.loadedSuscription.unsubscribe();
    this.selectedVehiculeSubs.unsubscribe();
    this.intervaleDateSubscription.unsubscribe();
    if (this.isMultiSelectTrajet$) {this.isMultiSelectTrajet$.unsubscribe();}
    if (this.selectedTrajets$) {this.selectedTrajets$.unsubscribe();}
    this.toolKmJourService.setIsMultiSelectTrajet(false);
    if (this.fullTrajets$) {this.fullTrajets$.unsubscribe();}
    this.toolKmJourService.setIsMultiSelectTrajet(false);

  }

}